// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1_iiv","cls2":"SimplePaperPodcast-cls2_WgC SimplePaperPodcast-cls1_iiv"};